import { FormView } from "../FormView";

export function WorkForStayPage() {
  return <FormView formId="work-for-stay" />;
}
